<div *ngIf="user" id="user-menu">
  <div class="start">
    <div class="logo">
      <img (click)="goToRoot()" src="assets/wonda/Logo_Wonda_W_icon_black.png" alt="logo" height="30px" matTooltip="Back to all Spaces" matTooltipShowDelay="500" />
    </div>
    <breadcrumbs></breadcrumbs>
  </div>

  <div class="end">
    <div *ngIf="(hubObs | async) && isFreePlan()" class="free-plan-tooltip" (click)="contactSales()">Free Plan</div>
    <div class="top-link" (click)="openHelp()" matTooltip="Open Help Center" matTooltipShowDelay="500">
      <mat-icon fontSet="fa" fontIcon="fa-circle-question"></mat-icon>
    </div>
    <div *ngIf="(hubObs | async) && isAdminOfHub()" class="top-link" (click)="openHubSettings()" matTooltip="Hub Settings" matTooltipShowDelay="500">
      <mat-icon fontSet="fa" fontIcon="fa-gear"></mat-icon>
    </div>
    <div *ngIf="(hubObs | async) && isAdminOfHub()" class="top-link" (click)="openAnalytics()" matTooltip="Hub Analytics" matTooltipShowDelay="500">
      <mat-icon fontSet="fa" fontIcon="fa-chart-column"></mat-icon>
    </div>
    <mat-menu class="top-mat-menu" #appMenu="matMenu" yPosition="below" xPosition="after" [overlapTrigger]="false">
      <div mat-menu-item [routerLink]="['/account']"><mat-icon>account_circle</mat-icon> Edit my Account</div>
      <mat-divider></mat-divider>
      <div class="hub-menu" mat-menu-item *ngFor="let hub of user.Hubs">
        <div class="gotohub" (click)="switchHub(hub)">
          <div *ngIf="!hub.logo || !hub.logo.path">{{ hub.title }}</div>
          <img *ngIf="hub.logo && hub.logo.path" class="hub-icon" src="{{ hub.logo.path }}" alt="{{ hub.title }}" />
        </div>
        <!-- <ng-container *ngIf="isAdminOfHub(hub.id)">
          <div class="settings-separator"></div>
          <div>
            <mat-icon class="mat-icon-right" (click)="editHub(hub)" style="color:white">settings</mat-icon>
          </div>
        </ng-container> -->
      </div>
      <mat-divider></mat-divider>
      <div mat-menu-item (click)="signOut()"><mat-icon>exit_to_app</mat-icon> Logout</div>
    </mat-menu>

    <button class="top-menu-button" mat-button [matMenuTriggerFor]="appMenu">
      <img *ngIf="user.photo" class="user-image" width="24px" height="24px" src="{{ user.photo }}" alt="" />
    </button>
  </div>
</div>
